<template lang="pug">
.bus-map.p-t-50.p-b-50
  .wrapper
    table
      tr.bus-map--item(v-for="(station, index) in allStations")
        td
          .spacer
            span(v-if="allStations[index].stops.indexOf(currentStop.id) !== -1") You Are Here
        td
          .dot-container
            .dot.flex.align-center.justify-center.current(v-if="station.stops.indexOf(currentStop.id) !== -1")
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21.158 20.178"><path data-name="Path 6" d="M20.822 8.429l-4.616 4.5 1.1 6.357a1.936 1.936 0 01.011.256c0 .33-.152.636-.52.636a1.029 1.029 0 01-.509-.154l-5.707-3-5.709 3a1.071 1.071 0 01-.509.154c-.368 0-.535-.306-.535-.636a1.67 1.67 0 01.027-.256l1.093-6.357-4.627-4.5a.984.984 0 01-.319-.611c0-.381.395-.533.712-.585l6.383-.928L9.957.52c.114-.241.33-.52.624-.52s.509.279.623.52l2.86 5.785 6.383.928c.3.051.712.2.712.585a.941.941 0 01-.337.611z" fill="#fff"/></svg>
            .dot(v-else)
            .arrow
        td
          .title(v-if="index != 0 && allStations[index - 1].stops.indexOf(currentStop.id) !== -1")
            strong
              span {{ station.name }} 
              span(v-if="specialText(index)") {{ specialText(index) }}
          .title(v-else)
            span {{ station.name }} 
            span(v-if="specialText(index)") {{ specialText(index) }}
</template>

<script>
  export default {
    name: 'BusMap',
    props: {
      currentStop: Object
    },
    data(){
      return {
        allStations: []
      }
    },
    mounted(){
      this.allStations = this.$store.state.stations
      if(this.currentStop.direction == 'north'){
        //reverse the station order and remove sproat because it is south only
        this.allStations = this.allStations.reverse().filter(s => s.stops[0] !== 2537729)
      } else {
        //remove adelaide because it is north only
        this.allStations = this.allStations.filter(s => s.stops[0] !== 2537706)
      }
    },
    methods: {
      specialText(index){
        let text = []

        if(index == 0){
          text.push('Start')
        }

        if(index == this.allStations.length - 1){
          text.push('End')
        }

        if(index != 0 && this.allStations[index - 1].stops.indexOf(this.currentStop.id) !== -1){
          text.push('Next Stop')
        }

        return text.length ? `(${text.join(' - ')})` : ''
      }
    }
  }
</script>

<style lang="sass" scoped>
  @import '@/sass/variables'
  
  // .light-theme 
  //   .bus-map
  //     background: $white
  //     color: $black
  //   .dot
  //     background: $dark-blue
  //   .arrow
  //     background: $dark-blue
  //     &::after
  //       border-top-color: $dark-blue
  // .dark-theme 
  //   .bus-map
  //     background: $blue
  //     color: $black
  //   .dot
  //     background: $black
  //   .arrow
  //     background: $black
  //     &::after
  //       border-top-color: $black
  
  .light-theme, .dark-theme
    .bus-map
      background: $white
      color: $black
    .dot
      background: $dark-blue
    .arrow
      background: $dark-blue
      &::after
        border-top-color: $dark-blue

  .bus-map--item
    position: relative
    &:last-of-type .arrow
      display: none
    td
      padding-bottom: 1rem
      vertical-align: middle

  .title
    flex: 1

  .title
    text-align: left

  .dot-container
    position: relative

  .dot
    width: 31px
    height: 31px
    border-radius: 50%
    margin: 0 1rem
    &.current
      background: $red
      svg
        width: 60%
        height: 60%
        position: absolute
        top: 50%
        left: 50%
        transform: translate(-50%, -50%)

  .arrow
    position: absolute
    top: 100%
    left: 50%
    height: 1rem
    width: 2px
    background: $white
    transform: translateX(-50%)
    &:after
      content: ''
      border-top: 5px solid $white
      border-left: 5px solid transparent
      border-right: 5px solid transparent
      display: block
      position: absolute
      left: 50%
      bottom: 0
      transform: translateX(-50%)
</style>